export const convertCC = (n) => {
	const num = Number(n)
	if (isNaN(num)) return 0
	const arr = num.toString().split('.')

	if ((arr.length > 1 || num.toString().length === 1) && num < 5) {
		return num.toFixed(3)
	}

	const cc = num / 1000
	return cc.toFixed(3)
}
